import { Form, Grid, Select, Text } from '@approvalmax/ui/src/components';
import { useVendorTemplateFieldSettings } from 'pages/requestForm/containers/netsuite/hooks';
import {
    isFieldMandatory,
    isFieldVisible,
} from 'pages/requestForm/containers/netsuite/NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { memo } from 'react';

import { messages } from './CurrenciesInformation.messages';
import { CurrenciesInformationProps } from './CurrenciesInformation.types';

export const CurrenciesInformation = memo<CurrenciesInformationProps>((props) => {
    const { currencies } = props;

    const fieldSettings = useVendorTemplateFieldSettings();

    return (
        <Form.Part>
            <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight80' spacing='20 0'>
                {messages.currenciesSection}
            </Text>

            <Grid gridTemplateColumns='1fr 1fr' gap={16} alignItems='end'>
                <Select
                    label={messages.primaryCurrency}
                    required={isFieldMandatory(fieldSettings.currency)}
                    name='currencyId'
                    placeholder={messages.selectPlaceholder}
                    autocomplete
                    items={currencies}
                    itemNameKey='text'
                    clearable={!isFieldMandatory(fieldSettings.currency)}
                />

                {isFieldVisible(fieldSettings.currencies) && (
                    <Select
                        label={messages.currenciesList}
                        name='currenciesIds'
                        placeholder={messages.selectPlaceholder}
                        autocomplete
                        items={currencies}
                        itemNameKey='text'
                        multiple
                    />
                )}
            </Grid>
        </Form.Part>
    );
});

CurrenciesInformation.displayName = 'CurrenciesInformation';
